module.exports = __webpack_public_path__ + "img/website_management.19f3605d.png";